<template>
  <b-container fluid>
    <div class="d-flex">
      <Main />
      <Sidebar class="d-none d-lg-block" />
    </div>
    <PriceModal class="d-lg-none" />
  </b-container>
</template>
<script>
import Main from "./Main";
import Sidebar from "./Sidebar";
import PriceModal from "./PriceModal";

export default {
  components: {
    Main,
    Sidebar,
    PriceModal,
  },
};
</script>